import { HTTP } from "../helpers/http-common.js";
import authHeader from "../helpers/auth-header";
import helpers from "../helpers/helpers";

const openBoxesService = {
  getTodaysOpenBox,
  storeOpenBox
};

export default openBoxesService;

//Get report invoices
function getTodaysOpenBox() {

  return HTTP.get(`todays-open-box`, {
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function storeOpenBox(item = {}) {
    return HTTP({
      method: 'post',
      url: 'store-open-box',
      data: item,
      headers: {
        'Authorization': authHeader(),
        'x-Company': helpers.getCompanyId()
  
      }
    });
  }